import MaterializeButton from './sh-btn';

export default MaterializeButton.extend({
  tagName: 'button',
  attributeBindings: ['disabled', 'form'],
  type: 'submit',

  click() {
    // override sh-btn's click behavior to avoid calls to non-existent actions.
  },
});
